import React from 'react';
import TableView from '@components/TracksHistory/TableView';

const TracksHistory = () => {
  return <TableView />;
};

export default TracksHistory;
